import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAY7GD1TIrufAEWbkWIQXxOMcmNVy2_SfY',
  authDomain: 'mycircle-app.firebaseapp.com',
  projectId: 'mycircle-app',
  storageBucket: 'mycircle-app.appspot.com',
  messagingSenderId: '142357942112',
  appId: '1:142357942112:web:70803ad35c9cf5c2abd805',
  measurementId: 'G-13VFRCB4HC',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const auth = getAuth();
export const googleAuthProvider = new GoogleAuthProvider();
export const facebookAuthProvider = new FacebookAuthProvider();

export const db = getFirestore();
